import React, { createContext, useContext, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { isSportsBettingPopupEnabled } from '../config/sportsBettingConfig';

const SportsBettingContext = createContext();

export const useSportsBetting = () => {
  const context = useContext(SportsBettingContext);
  if (!context) {
    throw new Error('useSportsBetting must be used within a SportsBettingProvider');
  }
  return context;
};

export const SportsBettingProvider = ({ children }) => {
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  const showSportsBettingPopup = useCallback(() => {
    if (isSportsBettingPopupEnabled()) {
      setShowPopup(true);
    } else {
      // If popup is disabled, navigate normally to sports betting
      navigate('/sports-betting');
    }
  }, [navigate]);

  const hideSportsBettingPopup = useCallback(() => {
    setShowPopup(false);
    navigate('/');
  }, [navigate]);

  const value = {
    showPopup,
    showSportsBettingPopup,
    hideSportsBettingPopup
  };

  return (
    <SportsBettingContext.Provider value={value}>
      {children}
    </SportsBettingContext.Provider>
  );
}; 